export const startsWithPunctuationRegex = /^[.,\/#!%\^&\*;:=\-_`~)]/

export const endsWithOpeningPunctuationRegex = /[([]$/

export const isAnEditRegex = /{\+([^|}]*)-([^|]*)\|([^}]*)}/g

export const negativeMatchRegex = /\-(.+)\|/m
